import { render, staticRenderFns } from "./CoveredInfo.vue?vue&type=template&id=04cbc5a7"
import script from "./CoveredInfo.vue?vue&type=script&lang=js"
export * from "./CoveredInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports